import { useMutation, useQuery, useQueryClient } from "react-query";
import { planBTAPI } from "../../services/planAPI";
import { AxiosError } from "axios";
import { PlanBTPatch } from "../../types/planBT.types";
import { FileUrl } from "../../../../common/components/molecule/FileListManager/FileListManager";

export interface SinglePlanBTCore {
  planBTId: string;
  setHeaderAuthToFutureResquest?: () => void;
}
export type CallbackFunction = (result: { result?: any; error?: any }) => void;
export default function useSinglePlanBTCore(config: SinglePlanBTCore) {
  config.setHeaderAuthToFutureResquest &&
    config.setHeaderAuthToFutureResquest();
  const singlePlanBTQuery = useQuery({
    queryKey: ["planBT", config.planBTId],
    queryFn: () => planBTAPI.getPlanBTById(config.planBTId),
    enabled: config.planBTId !== "",
  });
  const queryClient = useQueryClient();

  

  const updatePlanBT = useMutation({
    mutationFn: ({
      plan,
      file,
      callbackFunc,
    }: {
      plan: PlanBTPatch;
      file?: FileUrl;
      callbackFunc: CallbackFunction;
    }) =>
      planBTAPI
        .updatePlanBT(config.planBTId, plan, file)
        .then((result) => {
          callbackFunc({ result });
        })
        .catch((error: AxiosError) => {
          callbackFunc({ error });
          return Promise.reject(error);
        }),
    onMutate: () => {
      singlePlanBTQuery.refetch();
      queryClient.invalidateQueries("planBT");
    },
    onError: (error: AxiosError) => {
      console.error(error);
    },
  });

  const deletePlanBT = useMutation({
    mutationFn: ({ callbackFunc }: { callbackFunc?: CallbackFunction }) =>
      planBTAPI
        .deletePlanBT(config.planBTId)
        .then((result) => {
          callbackFunc&&
          callbackFunc({ result });
        })
        .catch((error: AxiosError) => {
          callbackFunc&&
          callbackFunc({ error });
          return Promise.reject(error);
        }),
    onMutate: () => {
      queryClient.invalidateQueries("planBT");
    },
  });


  


  return {
    singlePlanBTQuery: {
      ...singlePlanBTQuery,
      error: singlePlanBTQuery.error as AxiosError,
    },
    updatePlanBT: {
      ...updatePlanBT,
      error: updatePlanBT.error as AxiosError,
    },

    deletePlanBT: {
      ...deletePlanBT,
      error: deletePlanBT.error as AxiosError,
    },


  };
}
